// MSAL configuration for Azure Entra authentication
export const msalConfig = {
  auth: {
    // Paitar SPA App Registration
    clientId: "5448bff3-2050-48b4-9ec5-618d454df178",
    // Azure Entra tenant
    authority: "https://login.microsoftonline.com/714e4a1d-96ec-4e0a-86f0-8a0af2da16b6",
    // Redirect URI - update for production
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage", // More secure than localStorage
    storeAuthStateInCookie: false,
  },
};

// Scopes for PaiPlatform API access
export const loginRequest = {
  scopes: ["api://5de2f4f5-ea44-47a7-8919-d7af9c032a7e/access_as_user"],
};

// API configuration
export const apiConfig = {
  baseUrl: "https://paiservices.azurewebsites.net/api",
  scopes: ["api://5de2f4f5-ea44-47a7-8919-d7af9c032a7e/access_as_user"],
};
